export const CLASS_TYPES = [
  'Journey Begins Men',
  'Journey Begins Women',
  'Journey Continues Men',
  'Journey Continues Women',
];

export const MEETING_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// 30-minute increments from 6:00 AM to 11:30 PM (must match backend)
const MEETING_TIME_OPTIONS = [];
for (let h = 6; h <= 23; h++) {
  for (const m of [0, 30]) {
    if (h === 23 && m === 30) break;
    const hour = h === 0 ? 12 : h > 12 ? h - 12 : h;
    const ampm = h < 12 ? 'AM' : 'PM';
    const minStr = m === 0 ? '00' : '30';
    MEETING_TIME_OPTIONS.push(`${hour}:${minStr} ${ampm}`);
  }
}
export { MEETING_TIME_OPTIONS };
